<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Alergias / Reações adversas"
    >
        <ListAlergia
            :data="data"
            readonly
        />

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import ListAlergia from '@/components/cadastro/cidadao/components/alergia/List'

export default {
    components: {ListAlergia},
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
    },
    props: {
        data: {required: true, type: Object},
    },
}
</script>